import { ConfirmationDialog, QueryKeyTypes } from "../../../assets/types";
import { Constants } from "../../../assets/utils/lib/constants";
import { VfxDialogProps } from "../../../assets/vfx/dialog/vfxDialogProps";
import { LookupDto } from "../../../assets/utils/lib/lookupDto";

export namespace ViewProps {

    export interface UserLookupProps {
        roles: LookupDto[] | undefined;
        communities: LookupDto[] | undefined;
    }

    export const UserQueryKeys: Record<QueryKeyTypes, string> = {
        [QueryKeyTypes.None]: Constants.emptyString,
        [QueryKeyTypes.Get]: "userQuery",
        [QueryKeyTypes.Grid]: "userGridQuery",
        [QueryKeyTypes.Lookup]: "userlookupsQuery",
        [QueryKeyTypes.GetAll]: "usersQuery",
    }

    export const CommunityAdminRole: string = "9986D942-E0FF-457B-A442-8BD1BEBF8EB5";
    export const SuperAdminRole: string = "00AC21D2-23ED-4150-AF52-445D0A635AD9";

    export class UserConfirmationDialog extends ConfirmationDialog {

        private UnlockAccount: VfxDialogProps = {
            contentText: "Do you wish to unlock {{{Name}}}?",
            contentTitle: "Unlock Account",
            closeText: "No, Go Back",
            confirmText: "Yes, Continue",
            open: false,
            onClose: () => { },
            onConfirm: () => { },
        };

        private ResetPassword: VfxDialogProps = {
            contentText: "Are you sure you want to reset {{{Name}}} pasword?  An email will be sent to the user with the instructions to change password.",
            contentTitle: "Reset Password",
            closeText: "No, Go Back",
            confirmText: "Yes, Continue",
            open: false,
            onClose: () => { },
            onConfirm: () => { },
        };

        private ResendEmail: VfxDialogProps = {
            contentText: "Are you sure you want to resend confirmation email to {{{Name}}}",
            contentTitle: "Resend Email",
            closeText: "No, Go Back",
            confirmText: "Yes, Continue",
            open: false,
            onClose: () => { },
            onConfirm: () => { },
        };

        override get = (
            onConfirm: () => void,
            modalType: "Delete" | "Deactivate" | "UnlockAccount" | "Reset Password" | "Resend Email" | "Cancel",
            replaceValues?: Record<string, string> | undefined
        ): VfxDialogProps | undefined => {
            let dialogProps: VfxDialogProps | undefined = undefined;

            switch (modalType) {
                case "Deactivate": {
                    dialogProps = this.DefaultDeactivate;
                    break;
                }
                case "UnlockAccount": {
                    dialogProps = this.UnlockAccount;
                    break;
                }
                case "Reset Password": {
                    dialogProps = this.ResetPassword;
                    break;
                }
                case "Resend Email": {
                    dialogProps = this.ResendEmail;
                    break;
                }
            }

            if (dialogProps != undefined) {
                dialogProps.onConfirm = onConfirm;
                dialogProps = this.setContentText(dialogProps, replaceValues);
            }
            return dialogProps;
        };
    }
}